import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import { el, en } from 'vuetify/lib/locale'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#235878', // prussian blue
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#FFFFFF'
      },
      dark: {
        primary: '#3b7d9f',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        background: '#121212'
      }
    }
  },
  lang: {
    locales: { el, en },
    current: 'el'
  }
})
